import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Tlearning } from '../../../type/learning';
import { postDataPagesNoToken } from '../../../service/learningService';
import { MINIO } from '../../../data/data';
import { Autoplay } from 'swiper/modules';
import { FiCalendar } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const CarouselLearning = () => {
	const [learningList, setLearningList] = useState<Tlearning[]>([]);

	const getLearnings = async () => {
		const data = {
			pageNo: 0,
			pageSize: 10,
			sortType: 'DESC',
			filter: [
				{
					key: 'active',
					value: true,
					operation: 'EQUAL',
					conjunction: 'and',
				},
			],
		};
		const response = await postDataPagesNoToken(data);

		if (!response?.error) {
			setLearningList(response?.data.content);
		}
	};

	useEffect(() => {
		getLearnings();
	}, []);

	return (
		<>
			{learningList ? (
				<Swiper
					slidesPerView={3}
					modules={[Autoplay]}
					loop={true}
					autoplay={{
						delay: 1000,
						disableOnInteraction: false,
					}}
				>
					{learningList.map((item: Tlearning, index: number) => {
						const text = item.content_plain || '';
						const plain = text.substring(0, 100);
						return (
							<SwiperSlide key={index}>
								<div className="text-center overflow-hidden rounded-sm">
									<img
										src={`${MINIO}/${item.thumbnail}`}
										className="h-[250px] mx-auto"
										alt={item.name}
									/>
								</div>
								<h2 className="text-[13px] font-medium mt-2">{item.name}</h2>
							</SwiperSlide>
						);
					})}
				</Swiper>
			) : (
				<h4 className="text-center italic">--- Belum ada learning ---</h4>
			)}
		</>
	);
};

export default CarouselLearning;
